import { useEffect } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { useTelemetry } from '../../hooks/useTelemetry';
import { ACTIONS } from '../../telemetry/constants/actions';
import { MODULES } from '../../telemetry/constants/modules';

export default function PaymentFailure() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  // const { trackAction } = useTelemetry({ module: MODULES.BILLING, submodule: 'Payment Flow' });

  useEffect(() => {
    const planId = searchParams.get('plan_id') || undefined;
    const orderId = searchParams.get('order_id') || undefined;
    const errorMessage = searchParams.get('error') || undefined;

    // Redirect to profile subscription tab where the failure state is shown
    navigate('/profile?tab=subscription&payment=failed', { replace: true });
  }, []);

  return (
    <div className="min-h-screen flex items-center justify-center">
      <div className="flex items-center gap-3 text-gray-500">
        <div className="animate-spin rounded-full h-6 w-6 border-2 border-rose-500 border-t-transparent" />
        <span>Redirecting...</span>
      </div>
    </div>
  );
}